<template>
  <div class="container-main-body">
    <div style="position: relative; width: 50%; height: 100%; float: left; padding-top: 5px;">
      <div style="height: 30px;">
        <span style="margin-left: 10px; font-weight: bold;">搜索</span>
        <span style="margin-left: 10px;">样本册名称：</span>
        <el-input size="mini" v-model="query.productName" placeholder="请输入样本册名称" style="width: 140px;" clearable></el-input>
        <span style="margin-left: 10px;">页码：</span>
        <el-input size="mini" v-model="query.page" placeholder="请输入页码" style="width: 140px;" clearable></el-input>
        <!-- <span style="margin-left: 10px;">类型：</span>
        <el-input size="mini" v-model="query.type" placeholder="类型" style="width: 140px;" clearable></el-input> -->
        <el-button type="primary" size="mini" icon="el-icon-search" plain round @click="handlerSearchStores">搜索</el-button>
        <div style="float: right; height: 28px; line-height: 28px;">
          <el-button style="margin-right: 5px;" type="success" size="mini" icon="el-icon-refresh" @click="refreshStoreHandler">刷新</el-button>
        </div>
      </div>
      <div style="position: absolute; top: 35px; right: 5px; bottom: 5px; left: 0;">
        <el-table size="mini" ref="storeTable" :data="stores" style="width: 100%" height="100%" border header-row-class-name="list-header-row" row-class-name="list-row" highlight-current-row row-key="id" @current-change="handlerChangeStore">
          <el-table-column prop="product_name" label="样本册名称" width="100" align="center"></el-table-column>
          <el-table-column prop="material_name" label="物料名称" width="90" align="center"></el-table-column>
          <el-table-column prop="number" label="库存数量" width="60" align="center"></el-table-column>
          <el-table-column prop="table_number" label="台数" width="60" align="center"></el-table-column>
          <el-table-column prop="page" label="页码" width="60" align="center"></el-table-column>
          <el-table-column prop="position_value" label="库位" width="60" align="center"></el-table-column>
          <el-table-column prop="type" label="类型" width="60" align="center"></el-table-column>
          <el-table-column prop="create_time" label="创建时间" align="center"></el-table-column>
        </el-table>
      </div>
      <div class="pagination-container">
        <el-pagination background :current-page="query.pn" :page-size="query.pageSize" :total="query.totalCount" :page-sizes="[10, 15, 20, 25, 30, 50, 100]" layout="total, sizes, prev, pager, next, jumper" @size-change="pageSizeChange" @current-change="pageChange"></el-pagination>
      </div>
    </div>
    <div style="position: relative; width: 50%; height: 100%; float: right; padding-top: 5px;">
      <div style="float: right; height: 28px; line-height: 28px;">
        <el-button v-if="role_name === '超级权限' || role_name === '软件管理'" type="primary" size="mini" icon="el-icon-plus" @click="addChangeHandler">新增更改</el-button>
        <el-button type="success" size="mini" icon="el-icon-refresh" @click="refreshChangeHandler">刷新</el-button>
      </div>
      <div style="position: absolute; top: 35px; right: 0; bottom: 38px; left: 0;">
        <el-table size="mini" :data="changes" style="width: 100%" height="100%" header-row-class-name="list-header-row" row-class-name="list-row" border>
          <el-table-column prop="old_number" label="修改前数量" width="80" header-align="center"></el-table-column>
          <el-table-column label="修改后数量" width="90" align="center">
            <template v-slot:default="scope">
              <el-input size="mini" v-if="scope.row.edit_status==='是'" placeholder="修改后数量" v-model="scope.row.new_number"></el-input>
              <span v-else>{{scope.row.new_number}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="creater_name" label="修改人" width="80" align="center"></el-table-column>
          <el-table-column prop="create_time" label="修改时间" width="80" align="center"></el-table-column>
          <el-table-column label="备注" align="center">
            <template v-slot:default="scope">
              <el-input size="mini" v-if="scope.row.edit_status==='是'" placeholder="备注" v-model="scope.row.remark"></el-input>
              <span v-else>{{scope.row.remark}}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="90" align="center">
            <template v-slot:default="scope">
              <template v-if="scope.row.edit_status==='否' && (scope.$index === changes.length - 1)">
                <el-button type="primary" size="mini" circle icon="el-icon-edit" @click="scope.row.edit_status='是'"></el-button>
                <el-button type="danger" size="mini" circle icon="el-icon-minus" @click="delChangeHandler(scope)"></el-button>
              </template>
              <template v-if="scope.row.edit_status==='是' && (scope.$index === changes.length - 1)">
                <el-button type="success" size="mini" circle icon="el-icon-finished" @click="saveChangeHandler(scope.row)"></el-button>
                <el-button type="danger" size="mini" circle icon="el-icon-close" @click="scope.row.edit_status='否'"></el-button>
              </template>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data: function () {
    return {
      query: {
        productName: '',
        page: '',
        type: '',
        pn: 1, // 页码
        pageSize: 20, // 每页条数
        totalCount: 0 // 数据总条数
      },
      changeEmptyData: {
        id: '0',
        store_id: '0',
        old_number: '0',
        new_number: '0',
        remark: '',
        create_time: '',
        creater_id: '',
        edit_status: '是'
      },
      stores: [],
      changes: [],
      selectRow: [],
      creater_name: sessionStorage.getItem('operator'),
      operator_id: sessionStorage.getItem('operator_id'),
      role_name: sessionStorage.getItem('role_name')
    }
  },
  beforeCreate: function () {
    var date = new Date()
    var month = date.getMonth() < 9 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1
    var day = date.getDate() <= 9 ? '0' + date.getDate() : date.getDate()
    this.currentDate = date.getFullYear() + '-' + month + '-' + day
  },
  created: function () {
  },
  mounted: function () {
    this.loadData()
  },
  methods: {
    // 加载数据
    loadData: function () {
      const _this = this
      _this.post(_this.$apis.getStoresData, _this.query, function (res) {
        const _json = res.data
        if (_json.status && _json.status === 'logout') {
          _this.logout()
        } else {
          _this.stores = _json.datalist
          _this.query.totalCount = _json.totalCount
          if (_this.stores.length > 0) {
            _this.$refs.storeTable.setCurrentRow(_this.stores[0])
          }
        }
      })
    },
    loadChanges: function () {
      const _this = this
      if (_this.selectRow.length !== 0) {
        _this.post(_this.$apis.getChangeData, _this.selectRow, function (res) {
          let _json = res.data
          if (_json.status && _json.status === 'logout') {
            _this.logout()
          } else {
            _this.changes = _json.datalist
            _this.$forceUpdate()
          }
        })
      }
    },
    // 库存 行选择事件
    handlerChangeStore: function (_newRow, _oldRow) {
      this.selectRow = _newRow
      this.loadChanges()
    },
    // 搜索事件
    handlerSearchStores: function () {
      this.loadData()
    },
    // 刷新事件
    refreshStoreHandler: function () {
      this.loadData()
    },
    pageChange: function (pn) {
      this.query.pn = pn
      this.loadData()
    },
    pageSizeChange: function (pageSize) {
      this.query.pn = 1
      this.query.pageSize = pageSize
      this.loadData()
    },
    /**********************************************/
    // 新增更改
    addChangeHandler: function () {
      let detail = this.changes.filter(item => {
        if (item.id === '0') {
          return true
        }
      })
      if (detail.length > 0) {
        this.$message({
          type: 'warning',
          message: '请先保存修改'
        })
        return
      }
      let newDetail = JSON.parse(JSON.stringify(this.changeEmptyData))
      newDetail.store_id = this.selectRow.id
      newDetail.create_time = this.currentDate
      newDetail.old_number = this.selectRow.number
      newDetail.creater_name = this.creater_name
      newDetail.edit_status = '是'
      this.changes.push(newDetail)
    },
    // 刷新事件
    refreshChangeHandler: function () {
      this.loadChanges()
    },
    // 删除更改明细
    delChangeHandler: function (item) {
      const _this = this
      _this.$confirm('确定删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        if (item.row.id === '0') {
          _this.$delete(_this.changes, item.$index)
        } else {
          _this.post(_this.$apis.delChangeData, item.row, function (res) {
            let _json = res.data
            if (_json.status && _json.status === 'logout') {
              _this.logout()
            } else {
              if (_json.status === 'ok') {
                _this.$message({
                  message: '删除成功',
                  type: 'success'
                })
                _this.$delete(_this.changes, item.$index)
                _this.loadData()
                _this.loadChanges()
              }
            }
          })
        }
      }).catch(() => {
        _this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    // 表单验证
    validationHandler: function (_mainData) {
      let _this = this
      if (_mainData !== null) {
        if (_mainData[_mainData.length - 1].old_number === _mainData[_mainData.length - 1].new_number) {
          _this.$message({
            type: 'error',
            message: '修改前数量不能等于修改后数量'
          })
          return false
        }
      }
      return true
    },
    // 保存
    saveChangeHandler: function (_row) {
      let _this = this
      if (_this.validationHandler(_this.changes)) {
        _this.post(_this.$apis.saveChangeData, _row, function (res) {
          let _json = res.data
          if (_json.status && _json.status === 'logout') {
            _this.logout()
          } else {
            if (_json.status === 'ok') {
              _this.$message({
                message: '保存成功',
                type: 'success'
              })
              _row.edit_status = '否'
              _this.loadData()
              _this.loadChanges()
            }
          }
        })
      }
    }
  },
  components: {
  }
}
</script>
